import { AnalyticsAttributesProvider } from "../../components";
import { UiPricingGridModel } from "../../models";
import { renderViewModel } from "../../render-view-model";
import {
    isEnterprisePricingTiers,
    isFlatRatePricing
} from "../../utils/enterprise-pricing-calculator";

import { DefaultPlan, FlatRatePlan, TieredPlan } from "./components";
import PlanFeatures from "./components/PlanFeatures";
import { Grid, PlanContainer } from "./UiPricingGrid.styles";
import { Item, Title } from "./UiPricingGrid.styles";

export type UiPricingGridProps = {
    model: UiPricingGridModel;
};

const UiPricingGrid = ({ model }: UiPricingGridProps) => {
    const { appearance, plans } = model.content;
    return (
        <Grid
            planCount={
                plans.filter(({ type }) => type === "uiPricingPlan").length
            }
        >
            {plans
                .filter(({ type }) => type === "uiPricingPlan")
                .map((plan, index) => (
                    <PlanContainer key={index}>
                        <AnalyticsAttributesProvider
                            value={{
                                eventColumn: plan.content.entryTitle,
                                eventContainer: plan.type
                            }}
                        >
                            <Item
                                lgOrder={index}
                                highlight={plan.content.highlight}
                                top={true}
                                first={index === 0}
                                show={true}
                            >
                                <Title
                                    as={
                                        appearance === "Abbreviated"
                                            ? "h3"
                                            : "h2"
                                    }
                                >
                                    {plan.content.title}
                                </Title>
                            </Item>
                            {isFlatRatePricing(plan.content.pricing) ? (
                                <FlatRatePlan
                                    model={plan}
                                    index={index}
                                    planCount={plans.length}
                                    pricing={plan.content.pricing}
                                />
                            ) : isEnterprisePricingTiers(
                                  plan.content.pricing
                              ) ? (
                                <TieredPlan
                                    model={plan}
                                    index={index}
                                    planCount={plans.length}
                                    pricing={plan.content.pricing}
                                />
                            ) : (
                                <DefaultPlan
                                    model={plan}
                                    index={index}
                                    planCount={plans.length}
                                />
                            )}
                            <Item
                                lgOrder={index + plans.length * 3}
                                highlight={plan.content.highlight}
                                first={index === 0}
                                show={true}
                            >
                                {plan.content.buttons &&
                                    renderViewModel(plan.content.buttons)}
                            </Item>
                            {appearance !== "Abbreviated" && (
                                <Item
                                    lgOrder={index + plans.length * 4}
                                    highlight={plan.content.highlight}
                                    first={index === 0}
                                    show={true}
                                >
                                    <PlanFeatures model={plan} />
                                </Item>
                            )}
                            <Item
                                lgOrder={index + plans.length * 5}
                                highlight={plan.content.highlight}
                                bottom={true}
                                first={index === 0}
                                show={true}
                            >
                                {plan.content.learnMore &&
                                    renderViewModel(plan.content.learnMore)}
                            </Item>
                        </AnalyticsAttributesProvider>
                    </PlanContainer>
                ))}
        </Grid>
    );
};

export default UiPricingGrid;
